import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Typography from "@mui/material/Typography";
//Limitless imports
import { withi18n } from "../../../../customer/components";
const ViewContainer = ({
  t,
  classes,
  children,
  title,
  center,
  backgroundColor,
  isWizard,
  titleComponent,
  titleContainerStyle
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper,
    style: {
      backgroundColor
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: `${classes.viewContainer} ${isWizard ? classes.wizardViewContainer : ""}`
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.contentContainer
  }, titleComponent ? titleComponent : /*#__PURE__*/React.createElement("span", {
    className: titleContainerStyle
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    id: title,
    color: "textPrimary"
  }, t(title))), center ? /*#__PURE__*/React.createElement("div", {
    className: classes.centerChildren
  }, children) : children)));
};
const styles = () => ({
  wrapper: {
    height: "100vh",
    width: "100%"
  },
  viewContainer: {
    display: "flex",
    overflowY: "auto",
    overflowX: "hidden",
    height: "calc(100vh - 64px)",
    width: "100%"
  },
  wizardViewContainer: {
    height: "calc(100vh - 148px)"
  },
  contentContainer: {
    padding: 40,
    flex: 1,
    display: "flex",
    flexDirection: "column"
  },
  centerChildren: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }
});
export default withStyles(styles)(withi18n(ViewContainer));
ViewContainer.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  children: PropTypes.node,
  title: PropTypes.string,
  center: PropTypes.bool,
  backgroundColor: PropTypes.string,
  isWizard: PropTypes.bool,
  titleComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.array]),
  titleContainerStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
};
ViewContainer.defaultProps = {
  titleContainerStyle: "",
  backgroundColor: "#F9F9F9",
  isWizard: false
};